__turbopack_context__.v({
  "fade-in-ux308he": "worksList-module-scss-module__jpOBHa__fade-in-ux308he",
  "report": "worksList-module-scss-module__jpOBHa__report",
  "work-list": "worksList-module-scss-module__jpOBHa__work-list",
  "work-list-header": "worksList-module-scss-module__jpOBHa__work-list-header",
  "wrapper": "worksList-module-scss-module__jpOBHa__wrapper",
});
